import { Logger } from '@web-publish-id/logger'
import { ProviderAccessTokenCallback } from '../types'

export abstract class BaseProvider {
  protected logger: Logger = Logger.getInstance()

  protected constructor() {}

  /**
   * 授权
   * @returns 授权码
   */
  public abstract oAuth(success: ProviderAccessTokenCallback, fail: (e: any) => void): void
}
